function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/* THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY. */
import React, { forwardRef } from 'react';
import { jsx as ___EmotionJSX } from "@emotion/react";
var SvgInformation = /*#__PURE__*/forwardRef(function (props, svgRef) {
  return ___EmotionJSX("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), ___EmotionJSX("path", {
    fill: "currentColor",
    d: "M12.974 10.75c.103 0 .175.014.216.041s.06.077.06.148v5.871c0 .071-.02.12-.06.148s-.112.041-.216.041h-1.948c-.103 0-.175-.014-.216-.041s-.06-.077-.06-.148v-5.871c0-.071.02-.12.06-.148s.112-.041.216-.041h1.948zM13.013 7c.089 0 .15.022.185.065s.052.12.052.231v1.907c0 .111-.017.188-.052.231s-.096.065-.185.065h-2.027c-.089 0-.15-.022-.185-.065s-.052-.12-.052-.231V7.296c0-.111.017-.188.052-.231S10.897 7 10.986 7h2.027zM12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2zm0 2a8 8 0 1 0 0 16 8 8 0 0 0 0-16z"
  }));
});
export default SvgInformation;